import React, { Fragment, useCallback, useState } from 'react';
import FinancialProductContainer from './FinancialProductContainer';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from 'utils/functions';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { usePermission } from 'providers/RightsHooks';
import { useTranslation } from 'react-i18next';
import { ADMIN_FINANCIAL_PRODUCT_WRITE, ADMIN_FINANCIAL_PRODUCT_READ } from 'constants/rightsCodes';
import { useMutation, useSubscription } from 'hooks/apollo';
import { DUPLICATE_FINANCIAL_PRODUCT } from '../../list/mutations';
import { FINANCIAL_PRODUCT_DUPLICATED } from '../../list/subscriptions';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const productId = match.params.id && getInt(match.params.id);
  const [title, setTitle] = useState('');
  const [t] = useTranslation();

  const canWrite = usePermission(ADMIN_FINANCIAL_PRODUCT_WRITE);

  const onClickClose = useCallback(() => {
    historyContext.push(`/financialProducts`);
  }, [historyContext]);

  const onChangeTitle = useCallback(financialProductTitle => {
    setTitle(financialProductTitle);
  }, []);

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/financialProducts/${id}`);
    },
    [historyContext]
  );

  const [duplicateFinancialProduct] = useMutation(DUPLICATE_FINANCIAL_PRODUCT);

  useSubscription(FINANCIAL_PRODUCT_DUPLICATED, {
    onData: ({ data: { data } }) => {
      historyContext.push(`/financialProducts/${data.financialProductDuplicated.productId}`);
    }
  });

  const handleDuplicate = useCallback(() => {
    if (window.confirm(t('FinancialProduct.DuplicateFinancialProduct'))) {
      duplicateFinancialProduct({
        variables: {
          input: { productId: productId }
        }
      });
    }
  }, [duplicateFinancialProduct, productId, t]);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header canWrite={canWrite} title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} onDuplicate={handleDuplicate} canWrite={canWrite} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_FINANCIAL_PRODUCT_READ}>
        <FinancialProductContainer canWrite={canWrite} productId={productId} onRedirect={onRedirect} onChangeTitle={onChangeTitle} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
